import { PARTNER_SETTINGS } from 'src/services/GraphQL/Queries/B2bPartnerSettingsQuery';
import { graphQlRequest } from 'src/services/GraphQL/RequestHandler';
import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';

export const getPartnerSettingsQueryData = async (reqObj: {
  partnerKey: string;
}) => {
  try {
    const response = await graphQlRequest(
      PARTNER_SETTINGS,
      reqObj,
      GQL_QUERIES.PARTNER_SETTINGS
    );
    return response;
  } catch (error) {
    console.error('Error while fetching partner settings: ', error);
  }
  return null;
};
